import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import {
  Text,
  TextColor,
} from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { toCurrencyString } from '@delmonicos/shared-sdk/libs/core/src/utils/formatters/currency.formatters';
import { PriceComponent } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-hub-service/src/core/shared/models/price-component.model';
import { TariffDimensionType } from '@delmonicos/shared-sdk/libs/cpms/src/libs/ocpi/src/enums/ocpi-protocol-enums';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import * as css from '../tariff-details.module.scss';

interface PriceDetailsComponentProps {
  priceComponents: PriceComponent[];
  currency: string;
}

export const PriceDetailsComponent = ({
  priceComponents,
  currency,
}: PriceDetailsComponentProps): React.JSX.Element => {
  const { t } = useTranslation();

  const energy = useMemo(
    () => priceComponents.find((p) => p.type === TariffDimensionType.ENERGY),
    [priceComponents],
  );

  const time = useMemo(
    () => priceComponents.find((p) => p.type === TariffDimensionType.TIME),
    [priceComponents],
  );

  const parking = useMemo(
    () =>
      priceComponents.find((p) => p.type === TariffDimensionType.PARKING_TIME),
    [priceComponents],
  );

  return (
    <Stack
      gap={GapEnum.S}
      flex={1}
      alignItems="stretch"
      className={css.priceRow}>
      <Stack
        className={css.priceContainer}
        alignItems="center"
        justifyContent="center"
        flex={1}>
        <Text bold>
          {energy?.price !== undefined &&
            toCurrencyString(energy.price, currency)}{' '}
          <Text color={TextColor.Secondary} bold>
            / {energy?.stepSize} kWh
          </Text>
        </Text>
      </Stack>

      {(time || parking) && (
        <>
          <Text bold className={css.plusText}>
            +
          </Text>

          <Stack
            className={css.priceContainer}
            flex={1}
            direction="column"
            gap={GapEnum.M}>
            {time && (
              <Stack flex={1} justifyContent="center">
                <Text bold>
                  {time?.price !== undefined &&
                    toCurrencyString(time.price, currency)}{' '}
                  <Text color={TextColor.Secondary} bold>
                    / {time?.stepSize} min
                  </Text>
                </Text>
              </Stack>
            )}

            {parking && (
              <Stack className={css.parkingContainer} direction="column">
                <Stack justifyContent="center">
                  <Text bold>
                    {parking?.price !== undefined &&
                      toCurrencyString(parking.price, currency)}{' '}
                    <Text bold>/ {parking?.stepSize} min</Text>
                  </Text>
                </Stack>

                <Text italic>
                  {t('$.tariff-details.price.parking.description')}
                </Text>
              </Stack>
            )}
          </Stack>
        </>
      )}
    </Stack>
  );
};
